<template>
  <div class="index">
    <router-link :to="{ name: 'EmitentNewsCreator' }" class="button is-fullwidth">Добавить событие эмитента</router-link>
    <hr>
    <ul v-if="deponentsDataCopy.length" class="list">
      <b-table html
        :data="deponentsDataCopy"
        :bordered="false"
        :striped="false"
        :narrowed="false"
        :selectable="false"
        :checkable="true"
        :mobile-cards="false"
        :paginated="true"
        :per-page="10"
        render-html
        @dblclick="edit"
        @check="checked">
        <b-table-column field="publishDate" label="Дата публикации" sortable :format="formatDate"></b-table-column>
        <b-table-column field="registryClippingDate" label="Дата отсечения реестра" sortable :format="formatDate"></b-table-column>
        <b-table-column field="eventDate" label="Дата события" sortable :format="formatDate"></b-table-column>
        <b-table-column field="eventEndDate" label="Дата события по" sortable :format="formatDate"></b-table-column>
        <b-table-column field="fixationDate" label="Дата фиксации" sortable :format="formatDate"></b-table-column>
        <b-table-column field="eventTitle" label="Событие" sortable></b-table-column>
        <b-table-column field="data" label="Эмитенты" sortable :format="getName" class="emitents-data"></b-table-column>
      </b-table>
      <div>
        <button class="button is-danger" :disabled="!checkItems.length" @click="del">Удалить</button>
      </div>
    </ul>
    <div class="box interval-box">
      <b-field :type="intervalError && 'is-danger'" :message="intervalError" label="Интервал сканирования (в минутах)">
        <b-input type="number" v-model="interval" step="any" required></b-input>
      </b-field>
      <button :disabled="!interval" class="button is-info" @click="updateInterval">Сохранить</button>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'
  import { mapState, mapActions } from 'vuex'
  import deepcopy from 'deepcopy'

  export default {
    name: 'Events',
    data () {
      return {
        checkItems: [],
        interval: '',
        intervalError: ''
      }
    },
    computed: {
      ...mapState(['deponentsData', 'emitentsData']),
      deponentsDataCopy () {
        return deepcopy(this.deponentsData)
      }
    },
    created () {
      this.getDeponentsData()
      this.loadInterval()
    },
    methods: {
      ...mapActions(['getDeponentsData', 'deleteDeponentsData']),
      checked (items, item) {
        this.checkItems = items
      },
      async loadInterval () {
        try {
          this.intervalError = ''
          const { data } = await Vue.axios.get('/about/documents/emitent-news-interval')
          this.interval = data.interval
        } catch (error) {
          console.error(error)

          if (error.response && error.response.data) {
            this.intervalError = error.response.data.message
          }
        }
      },
      async updateInterval () {
        try {
          this.intervalError = ''
          const { data } = await Vue.axios.post('/about/documents/emitent-news-interval', { interval: this.interval })
          this.interval = data.interval
        } catch (error) {
          console.error(error)

          if (error.response && error.response.data) {
            this.intervalError = error.response.data.message
          }
        }
      },
      getName (obj) {
        if (obj && obj.length) {
          return obj.map(v => {
            const data = this.emitentsData.find(e => e.id === v)
            if (data) {
              return data.value + '\n'
            } else {
              return ''
            }
          }).join('')
        } else {
          return ''
        }
      },
      formatDate (value, row) {
        if (value) {
          return `<span class="tag is-primary">
            ${new Date(value).toLocaleDateString()}
          </span>`
        } else {
          return ''
        }
      },
      getEditButton (value, row) {
        return `<a href="/events/edit/${row.id}">
          Редактировать
        </a>`
      },
      edit (event) {
        this.$router.push({ name: 'EmitentNewsEditor', params: { id: event.id } })
      },
      del () {
        this.$dialog.confirm({
          message: 'Действительно удалить?',
          onConfirm: () => {
            for (const item of this.checkItems) {
              this.deleteDeponentsData(item.id)
              .then(() => this.$forceUpdate())
            }
          }
        })
      }
    }
  }
</script>

<style scoped>
td[data-label="Эмитенты"] {
  white-space: pre-line
}

.interval-box {
  margin: 16px 0;
}
</style>



// WEBPACK FOOTER //
// Index.vue?6b7d97c7